module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("PRE-1920"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title1"
  }, [_c('i', [_vm._v("Mountain Men, Good Samaritans and Life-Savers")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oregon’s volunteer search and rescue tradition began with the first wagon trains leaving Missouri on the Oregon Trail. The journey of over two thousand miles was daunting for even the most experienced frontiersmen. Early pioneers encountered an unforgiving landscape of arid deserts, high mountain passes and wild rivers. Hundreds died of disease, accidents, starvation and natural hazards along the route.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During Oregon’s settlement period, there was no formal system for search and rescue. When settlers fell victim to misfortune, they had to rely on their own courage and resourcefulness. If help did arrive, it was often days or weeks away and depended on the goodwill of neighbors who took it upon themselves to aid those in trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of Oregon’s first rescuers was Moses “Black” Harris, a fur trapper and scout who began guiding into Oregon Country in the 1830s. Little is known about his early life. Harris was of mixed-race ancestry and possibly the son of an enslaved mother."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN6",
      "id": "FT6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" He was famous for his powerful physique and ability to navigate through the mountains during winter. One account from the period described him as “fearless as an eagle, strong as the elk.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN7",
      "id": "FT7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" He was well-acquainted with various tribal groups and allegedly fluent in the Shoshone dialect."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN8",
      "id": "FT8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1836, Harris accompanied the Whitman-Spalding party during their journey to Fort Vancouver. He was a gifted storyteller who allegedly charmed Oregon pioneer Narcissa Whitman over tea during an encampment along the Platte River."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN9",
      "id": "FT9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" In the mid-1940s, Harris settled in Yamhill County and would subsequently lead two of the Oregon Trail’s most famous rescues.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The only known likeness of Moses “Black” Harris. Watercolor by Alfred Jacob Miller titled "), _c('i', [_vm._v("Trappers")]), _vm._v(", 1859. "), _c('i', [_vm._v("The Walters Art Museum of Baltimore")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1845, a party of over one thousand settlers with two hundred wagons hired Stephen Meek to lead them on a shortcut to the Willamette Valley. Meek’s route took them through the high deserts of eastern Oregon, along the Malheur River and into the Harney Basin. However, Meek wasn’t familiar with the area, and the path was poorly marked. When the party approached the Wagontire Mountains, east of Christmas Valley, they were already low on food and water, and several members had died of typhus."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN10",
      "id": "FT10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the situation became desperate, the party split into two groups. One group, led by Samuel Parker, set out through the desert, hoping to find the Crooked River. Wagon master Solomon Tetherow led a smaller group, including Meek, to the banks of the Deschutes River near Cline Falls."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN11",
      "id": "FT11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" The two parties eventually reunited and made their way to the area around the present-day Sherars Bridge, north of Maupin. However, they couldn’t find a way across the deep gorge on either side of the Deschutes River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the wagon train unable to advance, Meek went to The Dalles, hoping to organize a relief party. He arrived exhausted and desperate but found no one willing to help. Finally, Meek happened upon Moses Harris, passing through the area. The men knew each other from previous meetings, and when no one else volunteered to help, Harris agreed to lead the rescue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harris quickly organized a small party, including several Native Americans from the Warm Springs band who lived along the Columbia’s tributaries. They gathered food, water, ropes and fording materials before setting out on their mission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN12",
      "id": "FT12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Meek declined to join the rescue, unable to face the members of his abandoned party. When the rescuers arrived at the Deschutes, they found the pioneers on the verge of calamity, with “provisions nearly exhausted and the company weakened by exertion and despairing of ever reaching the settlements.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN13",
      "id": "FT13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After providing them with food, the rescue party began constructing a river crossing system using pulleys and wagon beds to ferry the settlers to safety, a method described by one observer as “novel in the extreme.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN14",
      "id": "FT14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" It took nearly two weeks to move all one thousand people across the river."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN15",
      "id": "FT15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" By the end of the ordeal, at least forty had died, but Harris and the other rescuers likely saved many more lives. A member of the rescued party described Harris as “a brave old mountaineer, one of the noblest.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN16",
      "id": "FT16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After that rescue, Harris was determined to find a better path from Fort Hall to the Willamette Valley."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN17",
      "id": "FT17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" He joined the Applegate brothers to scout a southern route through the Calapooya and Umpqua Mountains, linking up with the California Trail along the Humboldt River in Nevada. Perhaps more than anyone, the Applegate clan understood the dangers of the trail, having lost two sons during their family’s migration to Oregon when their boat overturned in the rapids on the Columbia River near The Dalles in 1843.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the late summer of 1846, Jessie Applegate recruited a party of some two hundred settlers for the first journey along the proposed route. The unproven shortcut presented numerous challenges, and the party was exhausted and running low on food by the time they crossed the Klamath River."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN18",
      "id": "FT18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" In the Calapooya Mountains, the settlers encountered torrential rains, part of the same historic weather system that trapped the Donner Party in California’s Sierra Nevada that November. Many of the migrants were forced to abandon their wagons and walk, experiencing “suffering beyond anything you have ever known,” according to one survivor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN19",
      "id": "FT19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P16-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Oregon Trail and its various cut-offs. Original map by Ross Smith. "), _c('i', [_vm._v("Used with permission of Ross A. Smith and modified by the author")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When news of the stranded wagon train reached the Willamette Valley in early December, citizen volunteers formed several rescue parties. Moses Harris led one relief party composed of several men with twenty-five horses and provisions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN20",
      "id": "FT20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Thomas Holt, a recent immigrant and resident of Polk County, organized another rescue party at his own expense. When Holt encountered the lead elements of the wagon train south of Eugene, they were “suffering almost beyond description” and unable to continue without assistance."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN21",
      "id": "FT21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rescue effort lasted nearly two months, until all the stragglers made it to the Willamette Valley. Only twenty wagons of the original one hundred made it to the end, and at least a dozen settlers died from typhoid fever and exposure. Despite Harris’s role in the rescue, he and the Applegates faced harsh criticism for promoting an unproven route. Nevertheless, Lindsay Applegate praised Harris for his actions during the rescue, declaring him a “brave and useful man.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN22",
      "id": "FT22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harris left Oregon the following year. The reason for his departure is unknown, but as a person of mixed race, he must have been acutely aware of the territory’s Black exclusion law enacted the year before he led the famous rescue along the Deschutes River. Harris died of cholera in Missouri two years after leaving Oregon City.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tragedy of Meek’s Cutoff was nearly repeated in 1853, this time along the Free Immigrant Road, also known as the Elliott Cutoff. The route had been partially scouted in 1852 but wasn’t well marked. It followed a similar course as Meek’s Cutoff into the Harney Valley, then took a different path south of Malheur Lake. Promotors billed it as a shorter, less expensive option than the Barlow Road south of Mount Hood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elliot recruited a party of around one thousand settlers with over 250 wagons."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN23",
      "id": "FT23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" They left Vale in late August but became bogged down in the Harney Basin and were low on food and water. A small group was sent ahead in mid-September to get help but lost their way when they mistook the Three Sisters for their intended route south of Diamond Peak. The advance party arrived in Springfield forty days later, barely alive and too late to help the rest of their group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, the main party reached the Deschutes River near Bend in early October, then traveled upstream looking for the path over the Cascades. When they couldn’t find the route, the settlers were forced to cut their way through dense forests past Crescent Lake and down the middle fork of the Willamette River."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN24",
      "id": "FT24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" By then, many had abandoned their wagons and struggled ahead on foot as their provisions ran out."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN25",
      "id": "FT25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-October, on the verge of starvation and with temperatures falling, a small group went ahead, hoping to find help. They were discovered near Butte Disappointment, overlooking present-day Lowell and the Dexter Reservoir. When word of the struggling wagon train reached the valley, residents of Lane, Linn and Benton Counties quickly organized a massive rescue effort involving hundreds of pack animals, cattle, dozens of wagons and tons of food and supplies—a rescue effort described in one account as “unequaled in the history of the West.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN26",
      "id": "FT26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rescue parties reached the lead wagons around Big Pine Opening upstream from the present-day town of Oakridge. Even with the rescuers’ help, it was an arduous journey, lasting several weeks before everyone was brought to safety. The party arrived in the lower Willamette Valley, starving and destitute, but somehow, only nine had died during the ordeal. The rescuers refused payment for their services, reportedly telling the new arrivals to “put away your purses. We have been there. We know how it is ourselves.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN27",
      "id": "FT27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the establishment of Oregon Territory in 1848, the federal government assumed a more significant role in protecting migrants along the trail. However, in the early 1850s, federal soldiers could scarcely care for themselves, much less anyone else. The first regiment to arrive in Oregon lost nearly seventy soldiers to accidents, disease and desertion during the trek from Fort Leavenworth to The Dalles."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN28",
      "id": "FT28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Some men were barefoot and barely able to walk when they arrived. Six soldiers drowned while moving supplies through the rapids on the Columbia River.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the Civil War, Congress authorized the construction of new wagon roads over the Cascades."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN29",
      "id": "FT29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" In addition to making for safer travel, the roads facilitated the movement of troops and commerce. But even improved roads didn’t guarantee safe passage over the mountains—demonstrated by the famous search for missing postmaster John Templeton Craig during the winter of 1877.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Craig had come to Oregon Territory from Ohio in 1852 and settled in the lower McKenzie Valley. In 1862, Captain Felix Scott hired him to lead a work crew cutting a new route from Eugene over the Cascades that would eventually become the path of the McKenzie Highway."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN30",
      "id": "FT30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" In 1877, Craig took over the contract for delivering mail along that route.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In December of that year, Craig left Belknap Springs on snowshoes carrying a heavy pack of mail heading for Camp Polk, about three miles northeast of the present-day town of Sisters. Craig had traveled the route many times but may have been ill as he began his climb up from the McKenzie River."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN31",
      "id": "FT31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" At the same time, a powerful winter storm hit the mountains. Authorities grew concerned when he didn’t arrive by early January."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN32",
      "id": "FT32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P18-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The memorial marker honoring John Templeton Craig near the cabin on McKenzie Pass where he sought shelter and died during a storm in December 1877. "), _c('i', [_vm._v("U.S. Forest Service")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A search party set out several weeks later but was forced back after the rescuers experienced snow blindness."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN33",
      "id": "FT33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" A second party of two experienced mountain men went out a few days later, struggling through ten feet of snow. They eventually made it to a cabin west of McKenzie Pass that Craig used as a stopover along his route. Inside the cabin, they found Craig’s body curled around a pile of ashes and ruined matches. There was a single snowshoe, leading them to surmise that the other one must have been lost or broken along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thwarted rescuers guessed that Craig had pushed through the storm to make the cabin, arriving cold and exhausted before lying down to sleep. Sometime during the night, his fire went out and couldn’t be restarted with wet matches. After the fact, a newspaper account suggested that the benefits of maintaining the mail route during winter months were “entirely inadequate to the dangers incurred.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN34",
      "id": "FT34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Today, a historical marker along the McKenzie Highway sits near the site where Craig took shelter and died in the cabin.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" U.S. L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IFE")]), _vm._v("-S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AVING")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERVICE ON THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGON")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OAST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the time of Craig’s death, inland search and rescue was a haphazard affair, entirely dependent on the initiative of Good Samaritans and mountain men. However, it was a different situation on Oregon’s coast as the U.S. Life-Saving Service opened its first station at Cape Arago, near Coos Bay, in 1878.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oregon’s coast was a dangerous environment for nineteenth-century travelers. Cold water, strong currents, frequent storms and hazardous sand bars created an unforgiving challenge for maritime navigation. As shipping expanded, so did the number of accidents, particularly along the stretch of coast between Tillamook Bay and the Columbia River Bar, known as the “graveyard of the Pacific.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN35",
      "id": "FT35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" For that reason, a professionalized search and rescue capability developed on the coast long before anywhere else in the state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The U.S. Life-Saving Service began on the East Coast as a series of shore-based stations with volunteer crews. The federal government began funding these stations in 1848 with the passage of the Newell Act."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN36",
      "id": "FT36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Oregon’s program began thirty years later as coastal shipping expanded along the Pacific Northwest.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P20-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Locations of life-saving and lifeboat stations along the Oregon coast. "), _c('i', [_vm._v("Map courtesy of David Pinyerd")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The Tillamook Bay Life-Saving crew with surfboat, circa 1910. "), _c('i', [_vm._v("U.S. Coast Guard")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially, the station at Cape Arago had only a keeper in charge with no paid crew. The keeper gathered volunteers from the local community to assist when a rescue was required. This ad hoc situation changed by the early 1890s when Oregon’s legislature pressured the federal government to fill the stations with paid, professional lifesavers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oregon’s first fully operational station was established at Point Adams near Astoria in 1889 with a crew of eight. Other stations were gradually created near known hazards and where crews could quickly access the water. They included stations on the Coquille River at Bandon in 1890 and the Umpqua River near Winchester Bay in 1890. By 1891, the Argo station had moved to a better location on the North Spit of Coos Bay and was staffed with a full-time professional crew. Two other stations were established at Yaquina Bay in 1896 and Tillamook Bay in 1908."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN37",
      "id": "FT37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crew members, known as “surfmen,” were generally under the age of forty-five and had a high level of physical fitness. Their responsibilities included lookout and patrol duties."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN38",
      "id": "FT38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Keepers generally lived at the stations with their families while the crews found accommodations nearby. Surfmen were often hired locally and served for many years in one location, ensuring they were familiar with the unique hazards of the area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The work schedule was a demanding regime of training and maintenance, with one day of rest per week on a rotating basis. Critical skills included boat launching, rowing through rough surf, capsizing drills, ship-to-shore rescue and medical training."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN39",
      "id": "FT39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" The work was inherently dangerous—and the pay was low—but the crews had pride in their work and strong esprit de corps. The surfmen were visible members of their coastal communities and often assisted with other public safety tasks when called upon, such as fighting fires and conducting rescues on land."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN40",
      "id": "FT40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The service’s unofficial motto was, “You have to go out, but you don’t have to come back.”")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P22-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Crew of the life-saving station at Point Adams near Astoria. Point Adams was Oregon’s first fully professional station, beginning active service in December 1889. "), _c('i', [_vm._v("Bandon Historical Society Museum")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the years of Oregon’s Life-Saving Service, several surfmen lost their lives in the line of duty. One incident occurred on the Coquille River bar in 1892, where three surfmen died during a training accident."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN41",
      "id": "FT41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Another incident happened during a rescue of the steamer "), _c('i', [_vm._v("Argo")]), _vm._v(" in November 1909 as it entered Tillamook Bay in stormy weather. A life-saving crew from the nearby Garibaldi station was transferring passengers from the ship when one of the rescue boats capsized in rough surf. Three passengers and a crewmember drowned before the other surfmen could reach them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN42",
      "id": "FT42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early Oregon life-saving stations were equipped with two kinds of rescue boats: a surfboat and a lifeboat. Surfboats were around twenty-five feet long and weighed as much as one thousand pounds."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN43",
      "id": "FT43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" The boats had a six-person crew who moved them to the water using a pull-cart or horses before launching them into the surf."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN44",
      "id": "FT44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" The surfboats were agile but exhausting to row.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oregon stations also had larger “Dobbins” lifeboats, rowed by a crew of eight. These boats could hold around thirty people and were self-righting and self-bailing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN45",
      "id": "FT45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" Around 1910, the service began distributing thirty-six-foot motorized lifeboats that significantly extended the range for rescues and saved the crews from the exhausting work of rowing out to wrecks. By 1915, all Oregon’s stations had at least one motorized vessel.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P23-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Surfmen of the Coquille River station evacuating casualties from a deadly train accident on the Seely-Anderson Logging Road near Bandon, November 1912. "), _c('i', [_vm._v("Bandon Historical Society Museum")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P23-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Three surfmen are honored by their crewmates following a deadly training accident on the Coquille River bar near Bandon, April 1892. "), _c('i', [_vm._v("U.S. Coast Guard")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P24-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A surfboat crew rowing through breakers near the notoriously dangerous mouth of the Coquille River. Construction of the north jetty is ongoing in the background. "), _c('i', [_vm._v("Bandon Historical Society Museum")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In cases where a ship was stranded closer to shore, the crew might opt to use a Lyle gun, named after its designer, U.S. Army ordnance officer Lieutenant David Lyle."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN46",
      "id": "FT46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The gun could propel a seventeen-pound projectile with a messenger line over six hundred yards. A stranded crew used the messenger line to draw over a heavier rope, enabling the surfmen to set up a pulley system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the pulley system was established, the shore-based rescuers could ferry stranded victims to safety using a breeches buoy. That device was a life preserver resembling a pair of oversize pants attached to a zip line. A trained crew of surfmen could set up the pulley system and breeches buoy in less than five minutes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN47",
      "id": "FT47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Stranded passengers and sailors climbed into the buoy to be shuttled from the wrecked vessel one person at a time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another shore-based rescue device was the life car, an enclosed pod enabling subjects to climb inside and close a watertight hatch behind them. The life car could hold four to five passengers and be pulled through the water to shore using the pulley system. Although the life car could move several victims at once, it was much heavier and more complicated to deploy.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P25-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A sketch of the life car rescue apparatus, circa 1893. "), _c('i', [_vm._v("U.S. Coast Guard")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P25-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A breeches buoy in use during a rescue, 1919. "), _c('i', [_vm._v("George Grantham Bain collection, Library of Congress")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P26-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Surfmen of the Yaquina Bay station practicing on the beach with a Lyle gun and breeches buoy. "), _c('i', [_vm._v("Lincoln County Historical Society")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the years that the Life-Saving Service operated along Oregon’s coast, surfmen responded to hundreds of wrecks and rescues. Two of these gained widespread attention: the wrecks of the "), _c('i', [_vm._v("Czarina")]), _vm._v(" and the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In January 1910, the steamer "), _c('i', [_vm._v("Czarina")]), _vm._v(" left Coos Bay with a crew of twenty-three and one passenger, carrying a large load of cement and timber bound for San Francisco."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN48",
      "id": "FT48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The crew encountered strong winds and high seas as they left the harbor. The ship passed over the bar and was near the jetties when it began having trouble."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN49",
      "id": "FT49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" After drifting in high surf, the "), _c('i', [_vm._v("Czarina")]), _vm._v(" grounded on South Spit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Violent waves damaged the ship’s lifeboats, setting them adrift in the storm. Unable to maneuver, the crew dropped anchor several hundred yards from shore and climbed into the rigging to escape the waves. Two nearby boats attempted to reach the crew but couldn’t maneuver close enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clarence Boice, the keeper of the lifeboat station at Coos Bay, had watched the "), _c('i', [_vm._v("Czarina")]), _vm._v(" leave the harbor. At the first sign of trouble, Boice alerted his surfmen. However, he decided that the sea was too rough for the lifeboats and ordered his crew to deploy the beach rescue equipment instead."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN50",
      "id": "FT50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" The life-saving crew brought the Lyle gun to the water’s edge and tried to fire it into a heavy wind, but it failed to reach the ship after several attempts.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P27-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Onlookers watch from shore as crewmembers of the "), _c('i', [_vm._v("Czarina")]), _vm._v(" cling to the rigging above the ship. Only one of the crewmembers survived. "), _c('i', [_vm._v("Photo by Arthur Prentiss; courtesy of David Pinyerd")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meanwhile, onlookers watched in horror as members of the "), _c('i', [_vm._v("Czarina")]), _vm._v("’s crew began dropping from the rigging into the water. Boice’s crew tried unsuccessfully to relaunch the surfboats through the rough surf but eventually gave up. In the early afternoon, a second crew from the Coquille River station, twenty miles to the south, joined the Coos Bay team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The crews worked through the night patrolling the beach, looking for survivors. But only one of the "), _c('i', [_vm._v("Czarina")]), _vm._v("’s crew made it to shore, kept afloat by grasping onto a piece of drifting timber. Several others lasted through the night by lashing themselves to the rigging. By morning, the weather had worsened, and no further attempt was made to reach the ship. At midday, no survivors were visible from shore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the aftermath of the tragedy, the community criticized Boice for not doing more to reach the ship and save the twenty-three men aboard. The Life-Saving Service investigated the incident and determined “that no human power could have succeeded in rescuing the men of the "), _c('i', [_vm._v("Czarina")]), _vm._v(".”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN51",
      "id": "FT51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Nevertheless, it determined that Boice should have attempted further efforts with Lyle gun and boats, and his failure indicated “a certain degree of incompetency.” Boice resigned but was eventually rehired as a surfman at the Coquille River station, where he had served before becoming the keeper at Coos Bay.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P28-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Surfman Clarence Boice posing in front of a Lyle gun, breeches buoy and Dobbins boat. Boice was accused of dereliction during the attempted rescue of the "), _c('i', [_vm._v("Czarina")]), _vm._v("’s crew in 1910 and was forced to resign as keeper of the Coos Bay station. "), _c('i', [_vm._v("Bandon Historical Society Museum")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A second notable incident involved the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" on the Columbia River Bar, a spot that claimed some two thousand boats and over seven hundred lives during the last two centuries. In January 1913, the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" was sailing from California to Portland with a cargo of oil when it encountered heavy swells and poor visibility."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN52",
      "id": "FT52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" According to witnesses, the captain ran the ship aground on Peacock Spit on the Washington side of the river. When the captain realized the danger, he dropped anchor, but by that time the boat was already heavily damaged and taking on water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A wireless operator in Astoria received the distress message from the ship. Several tugboats responded to the call but couldn’t approach the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" in heavy seas. Calls also went out to the life-saving stations at Point Adams and Cape Disappointment; however, the storm disrupted the telephone lines and delayed transmission of the message.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Daybreak revealed that the ship had broken in two parts on the spit, leaving only the pilothouse and masts visible above the waves."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN53",
      "id": "FT53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Some crewmembers climbed into the rigging as the waves battered the wreck. Unfortunately, the ship was located miles from shore, leaving no possibility of using the Lyle gun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The surfmen of the Cape Disappointment station set out in their thirty-six-foot motor surfboat, appropriately dubbed the "), _c('i', [_vm._v("Tenacious")]), _vm._v(", but returned to shore after three hours of fighting heavy surf, unable to reach the wreck. Next, the crew from Point Adams station set out in their surfboat, the "), _c('i', [_vm._v("Dreadnought")]), _vm._v(", but couldn’t locate the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" through the high seas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Crews from both stations made multiple attempts during the day to fight their way to the stranded sailors. During the effort, the "), _c('i', [_vm._v("Tenacious")]), _vm._v(" became severely damaged and capsized. The crew of the "), _c('i', [_vm._v("Dreadnought")]), _vm._v(" went to their rescue. After pulling the disabled "), _c('i', [_vm._v("Tenacious")]), _vm._v(" to a nearby tug, the "), _c('i', [_vm._v("Dreadnought")]), _vm._v(" crew returned to the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(". But by then, the remaining sailors had dropped from the rigging into the water.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The surfmen aboard the "), _c('i', [_vm._v("Dreadnought")]), _vm._v(" pulled two survivors from the water but couldn’t return to shore. They reached the lightship "), _c('i', [_vm._v("Columbia")]), _vm._v(" and transferred to the larger vessel. However, the "), _c('i', [_vm._v("Columbia")]), _vm._v(" couldn’t pull the "), _c('i', [_vm._v("Dreadnought")]), _vm._v(" to safety through the storm. The surfboat was set adrift, never to be seen again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, a single survivor from the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" washed ashore, miles from the wreck. Rescuers on shore took him to the life-saving station at Klipsan Beach in Washington. In total, thirty-four sailors of the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" were lost, making it the second-most deadly maritime disaster on the Columbia River bar in the twentieth century.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An investigation ultimately found fault with the captain of the "), _c('i', [_vm._v("Rosecrans")]), _vm._v(" for misjudging his course and running the ship aground on Peacock Spit. The two life-saving crews had failed to rescue most of the sailors and lost two surfboats in the effort, but the investigation found that they had done everything possible to save the crew. The surfmen of the two stations were awarded a total of sixteen gold life-saving medals, the most ever awarded by the service for a single rescue."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN54",
      "id": "FT54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1915, the U.S. Life-Saving Service merged with the Revenue Cutter Service, creating the modern United States Coast Guard. The new service assumed responsibility for maritime search and rescue operations along Oregon’s coast. The old life-saving stations continued to operate much as before. But now, the surfmen fell within the military chain of command, receiving similar pay and benefits as other service members.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bureaucratic transition to the Coast Guard brought about station closures and consolidations on the East Coast. However, Oregon saw continued expansion of its maritime safety infrastructure, including new stations on the Suislaw River in 1917 and at Port Orford in 1934. By World War II, the Coast Guard had thirteen stations along the Oregon coast, many of which were legacy sites from the era of the U.S. Life-Saving Service.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARCH AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCUE ON")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REGON")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UBLIC")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANDS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the late nineteenth century, Oregon’s public lands were largely undeveloped. Access was difficult, and there were few recreational opportunities. When President Theodore Roosevelt created the Forest Service in 1905, the agency was focused more on protecting forest lands from misuse than protecting citizens from hazards encountered while recreating there."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN55",
      "id": "FT55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That outlook would gradually change into the early twentieth century as the Forest Service began viewing recreation as a legitimate use of system lands. Oregon was among the first states where the Forest Service actively promoted outdoor recreation, aided by the rise of automobile ownership, which allowed citizens to access remote national forests. The first automobiles started appearing at Government Camp shortly after the turn of the century, bringing an increase in visitors to Mount Hood."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN56",
      "id": "FT56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" By the early 1920s, the area was one of the most visited national forests in the United States."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN57",
      "id": "FT57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the influx of visitors, search and rescue was still not among the Forest Service’s designated responsibilities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN58",
      "id": "FT58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" The function fell into the broad category of unstated duties expected of all forest rangers, who often acted as “the only policeman, fish and game warden, coroner, disaster rescuer, and doctor” in their district."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN59",
      "id": "FT59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" However, the rising popularity of outdoor recreation inevitably led to more accidents and mishaps, generating a need for search and rescue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before the founding of the Crag Rats in the mid-1920s, no formal search and rescue authority existed inside Oregon’s National Forests. That duty fell on a handful of district rangers and local outdoorsmen who volunteered their services when a rescue was required. Fortunately, the Forest Service employed some of the era’s best climbers and outdoorsmen. This included men such as forest ranger Adolph Aschoff, the first supervisor of the Cascade Range Forest Reserve, later known as the Mount Hood National Forest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aschoff settled near Sandy and opened a hotel frequented by early Mount Hood climbers traveling from Portland."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN60",
      "id": "FT60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" There he met the future Mazamas, William Steel and Oliver Yocum. Aschoff took up climbing and became a founding member of the Mazamas before joining the Forest Service.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P31-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Adolph Aschoff was a charter member of the Mazamas and the first supervisor of the Cascade Range Forest Reserve, later the Mount Hood National Forest. Lige Coalman would lead a search party for Aschoff’s son, who went missing in the summer of 1914. "), _c('i', [_vm._v("Courtesy of Gary Randall")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While serving as a ranger, Aschoff joined a Mazama outing in 1901, hosting Henry Fielding Reid, renowned geophysicist and the world’s leading authority on glaciers. One evening, Reid became so enthralled while exploring Zigzag glacier that he wandered away and failed to return to camp by nightfall. Aschoff set out into the darkness with a lantern to track down the famous scientist and guide him safely back to camp. Reid Glacier on Mount Hood’s western slope, the source of the Sandy River, was later named in honor of the rescued scientist."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN61",
      "id": "FT61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During those years, the Forest Service maintained a close relationship with the Mazamas and often used club members as an informal resource for search and rescue."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN62",
      "id": "FT62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" In later years, outdoor groups like the Skyliners and Obsidians would perform a similar role in the Deschutes and Willamette National Forests."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN63",
      "id": "FT63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Among those early informal rescuers was Oliver Yocum, a climbing guide on Mount Hood. As a young man, Yocum had been an actor, a farmer and a justice of the peace before becoming interested in photography and opening a studio in Portland."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN64",
      "id": "FT64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" In the summer of 1883, Yocum made his first climb of Mount Hood. On that climb, he carried an enormous load of photography equipment, taking the first known photographs from the summit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN65",
      "id": "FT65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yocum later moved to Government Camp, where he began working as a guide. In July 1901, he was involved in one of the era’s most unusual rescues while leading a climb during the Mazamas’ annual outing on Mount Hood."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN66",
      "id": "FT66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Yocum spotted a group of climbers having difficulty near Crater Rock, a triangular lava dome near the summit. A woman in the group was unconscious and needed to be brought down as a storm closed in.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A group of Mazamas went to her aid but didn’t have rescue equipment and were forced to improvise. One of the Mazamas wrapped himself in an overcoat and lay flat on the ground, turning himself into a human toboggan. The unconscious woman was lowered over a mile across a snowfield, riding atop her rescuer. She was transferred to a horse at the edge of the snowline and taken to Government Camp, where she received medical care."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN67",
      "id": "FT67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Elijah “Lige” Coalman was another legendary mountaineer and rescuer who worked for the Forest Service. In 1897, at the age of sixteen, Coalman made his first ascent of Mount Hood, guided by Oliver Yocum. Over several summers, Yocum trained Coalman in climbing, and they eventually went into business together as guides and running a hotel at Government Camp until Yocum retired in 1910.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coalman was known for his tremendous physical endurance and unfailing willingness to help those in need. He made his first rescue at the age of seventeen, pulling a drowning man from the storm-swollen Sandy River. The man was unconscious and not breathing when pulled to shore. Coalman placed the man on his stomach and rolled him vigorously until he began breathing again, using the accepted method of resuscitation at the time."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN68",
      "id": "FT68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By his early thirties, Coalman was living at Government Camp and had become one of Oregon’s most experienced mountain guides. By that time, he was also a legendary rescuer. Late one evening in December 1914, a half-frozen man stumbled into Government Camp with news that a family traveling with a baby was trapped in the snow in the direction of Rhododendron. They had come from nearby Sandy, planning to spend the winter as caretakers of a farm and sanitarium near Clackamas Lake.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coalman set out in the middle of the night with two other men to find the stranded family. The temperature was near zero, with nine feet of snow on the ground as they left Government Camp."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN69",
      "id": "FT69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" When the rescuers found them, the parents were suffering from frostbite and exposure, having used what little they had to protect their baby. After Coalman got them back to Government Camp, the family spent the next four days recovering before he escorted them by snowshoe some sixteen miles to Clackamas Lake, towing a toboggan full of supplies and the young child."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN70",
      "id": "FT70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But his mission didn’t end there. Coalman encountered three other caretakers waiting at the farm who needed help back to Government Camp. The party included a man severely ill with the flu and unable to walk. Coalman towed him in a toboggan for the two-day journey back to Government Camp, where the man convalesced for a week before continuing to Portland.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following summer, while working for the Forest Service, Coalman built the summit cabin on the top of Mount Hood. He hauled up most of the supplies with the assistance of government packer Dee Wright. In 1916, Coalman became the first fire lookout, and the summit hut became the starting point for many rescue missions. That summer, a Portland climber went missing for two nights when Coalman spotted him staggering near the edge of a crevasse on the Zigzag Glacier. Coalman glissaded down from the summit in fifteen minutes, reaching the climber just in time and leading him to safety."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN71",
      "id": "FT71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following year, Coalman rescued the famous Swiss-born guide Hans Fuhrer, who had been severely injured while glissading down from the Hogsback, a prominent saddle between Crater Rock and the main summit. Fuhrer’s ice axe cut deeply into his abdomen, exposing his intestines. Coalman saw the group waving for help and raced to their aid. He dressed the abdominal wound and moved Fuhrer down the mountain using an improved rucksack toboggan. The surgeons at Portland’s St. Vincent Hospital were reportedly impressed by the expertise of Coalman’s impromptu field dressing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN72",
      "id": "FT72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P34-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Elijah “Lige” Coalman ("), _c('i', [_vm._v("left")]), _vm._v(") carrying supplies up to the summit lookout on Mount Hood. "), _c('i', [_vm._v("U.S. Forest Service")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coalman summited Mount Hood nearly six hundred times during his career. But in 1918, he became the subject of a rescue after being injured by a rockfall on Cooper Spur, a large moraine extending northeast from the summit. The day after his injury, Coalman returned to the summit cabin but couldn’t move the next morning. He called the Zigzag district ranger using a phone line linked to the summit hut. The ranger organized a rescue party to carry Coalman down from the top of Mount Hood."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN73",
      "id": "FT73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Coalman never fully recovered from that incident but continued working intermittently for the Forest Service and even continued participating in rescues into the 1920s. When he died in 1970, the Oregon Geographic Names Board designated a small glacier in his honor, located between the White River and Zigzag Glaciers. The Coalman Glacier contains two features on the popular south side climbing route that have been the site of numerous rescues over the years: the Hogsback, a prominent snow ridge extending from Crater Rock toward the summit ridge, and the infamous “Bergschrund” crevasse, one of the obstacles facing climbers as they near the summit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The early mountain men working for the Forest Service around Mount Hood were a tight-knit fraternity that came to the aid of strangers and each other. In 1914, Adolph Aschoff’s son became the subject of a highly publicized search when he went missing for several days from his family’s home near Sandy. Coalman volunteered to lead the extensive search operation that located the young man’s body a week later. Suicide was suspected."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN74",
      "id": "FT74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARCH AND")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCUE IN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RATER")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AKE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIONAL")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike the early National Forests, which were created primarily for resource management, the National Park System was meant to bring Americans in contact with nature for “enjoyment, education, and inspiration.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN75",
      "id": "FT75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Thus, providing a safe environment for visitors was an implied aspect of the agency’s mission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN76",
      "id": "FT76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" For that reason, the National Park Service assumed a more proactive role regarding search and rescue within its jurisdiction."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN77",
      "id": "FT77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Crater Lake was established in 1902, it became the fifth national park in the United States and the only one in Oregon. At the time, the area was remote and difficult to access. This kept away all but the hardiest adventurers, who were generally self-reliant and accustomed to wilderness travel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Crater Lake opened, it operated with minimal staff from a headquarters at Bridge Creek Springs, six miles from the lake. William Arant was the park’s first superintendent. At the time, he was the only staff member available for year-round search and rescue."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN78",
      "id": "FT78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" By 1906, the park was attracting around 1,700 visitors annually, and Arant was increasingly concerned about the potential hazards to guests. His annual report that year noted the “danger of accident or even loss of life” at some of the more exposed overlooks and trails around the crater’s rim."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN79",
      "id": "FT79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1907, he hired Henry Momyer of Klamath Falls as the first seasonal ranger. Momyer’s duties included enforcing park regulations, protecting resources, preventing and controlling forest fires and operating the park’s entrance stations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN80",
      "id": "FT80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" During those early years, Arant and Momyer attended to numerous guests needing rescue while visiting the park.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the more notable incidents involved a professional photographer named B.B. Bakowski of Oregon City, who set out for the lake from Fort Klamath in January 1911. The young man took a month’s worth of provisions, intending to camp near the lake and take photographs for postcards. When he failed to return by mid-February, several volunteer search parties set out to find him. An early search group located Bakowski’s sled and a shovel near the crater rim in Munson Valley but not the rest of his gear.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P36-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Crater Lake Park superintendent William Arant and forest ranger Henry Momyer ("), _c('i', [_vm._v("lower left corner")]), _vm._v(") pose for a photo after rescuing two women who went missing near Kerr Notch, 1908. "), _c('i', [_vm._v("NPS History Collection/Dewey Huffman")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An extended blizzard from late February into early March brought over twelve feet of snow and subzero temperatures, hampering search efforts. After the storm cleared, a second search party from Medford reached the lake by snowshoe. The men found Bakowski’s camera equipment but no trace of the photographer, leading them to assume the worst."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN81",
      "id": "FT81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" In early March, park ranger Momyer discovered a canvas tarp stretching across the mouth of a snow tunnel. Bakowski’s telescope, clothes and provisions were inside the tunnel, but there was no sign of his body.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Superintendent Arant and Ranger Momyer continued searching for Bakowski through the spring and summer of that year, but his remains were never found. It was the park’s first recorded loss of a visitor. After that, Arant recommended a prohibition on winter travel inside the park from December through May without written permission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1915, the Crater Lake Lodge opened, with the Rim Drive completed three years later. As the park’s infrastructure improved, it began attracting visitors less familiar with the outdoors. Crater Lake still didn’t have a designated search and rescue unit, so the tiny staff was increasingly responding to emergencies in the park."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN82",
      "id": "FT82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the 1920s, Park Service supervisors regularly reported on rescue incidents as part of their annual reports. At the first Chief Ranger’s Conference held in Sequoia National Park in 1926, visitor safety, rescue and law enforcement were topics on the agenda."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN83",
      "id": "FT83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" That same year, Congress passed legislation formally directing the secretary of the interior “to aid and assist visitors within the national parks or national monuments in emergencies.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN84",
      "id": "FT84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Although such activities had occurred regularly since the establishment of Yellowstone National Park in 1872, the legislation marked the first time the Park Service formally authorized and funded a search and rescue function. The law also provided for medical care and evacuation of park employees working at isolated locations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On-site medical services first appeared at Crater Lake in the late 1920s when Dr. R.E. Green of Medford began working seasonally at the park. Dr. Fred Miller, head of the University of Oregon’s health service program, also worked there under contract during the summer months."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN85",
      "id": "FT85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" Still, the park remained woefully understaffed through the 1920s. By the middle of the decade, there was only one full-time ranger and eight seasonal rangers responsible for protecting an area of 249 square miles, receiving well over 100,000 visitors each year."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN86",
      "id": "FT86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" In the fall of 1930, the consequences of that understaffing became tragically apparent.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/P37-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Superintendent William Arant inspects the campsite of B.B. Bakowski, who disappeared in the park during the winter of 1910. Despite extensive searches, Bakowski’s body was never found. "), _c('i', [_vm._v("Douglas County Museum")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That year, an early-season storm brought over thirty inches of snow to the region, trapping several guests inside the park. Chief Ranger William Godfrey drove from Fort Klamath through the west entrance, trying to reach the stranded guests but found the road blocked by snow. Godfrey then drove to the south entrance near Annie Springs and spent the night in his car. The next morning, he called an operator at Fort Klamath and told her he was going into the park on foot, planning to rendezvous with a snowplow and retrieve the trapped guests. However, the plow was already working to open the west road, and the driver never reached Godfrey.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Later that morning, Ranger Rudy Luech learned of Godfrey’s plan from the operator in Fort Klamath. When he hadn’t heard from Godfrey, Luech organized a search party and set out on skis to find him. Around nine o’clock that evening, Luech found Godfry collapsed in the snow two miles from the Annie Springs entrance station. Godfrey was alive when the search party reached him but died shortly after from exposure."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN87",
      "id": "FT87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" He was forty-one years old and had been the park’s chief ranger for only a year. After his death, Superintendent E.C. Solinsky named the park’s Godfrey Glen Trail in his honor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the 1930s, the ranger force gradually expanded, but so did the number of incidents. During the mid-1930s, a series of accidental deaths led the park administration to focus more on visitor safety, protection and rescue operations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN88",
      "id": "FT88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" The first incident involved a capsized boat near Wizard Island that took rescuers over an hour to reach, resulting in one death. Shortly after, there were two more deaths caused by visitors falling over the crater rim. There were also reports of numerous guests needing rescue after climbing down the crater wall and becoming stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In response to the rising number of incidents, Park Superintendent Ernest Leavitt and Chief Ranger Carlisle Crouch created a ranger training school in 1938 to help prepare new rangers for the job’s demands. Crouch also wanted a new, permanent ranger station located at the Rim Village to help deal with the rising number of fatalities and accidents around the lake, including water rescues, searches for lost persons and recovering bodies from the crater."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN89",
      "id": "FT89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the time, Crouch proposed creating a new ranger position responsible for visitor services, including first aid, rescue and other emergency services. However, the start of World War II significantly reduced park operations, and the position was never filled. After the war, the park gradually increased its training for search and rescue. By the early 1960s, SAR was among the designated duties for supervisory park rangers assigned to Crater Lake."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Notes#FN90",
      "id": "FT90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 75
// module chunks = 0